var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "navigation-tab",
    class: {
      'active': _vm.active
    },
    attrs: {
      "href": "#".concat(_vm.tab.key)
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click', _vm.tab);
      }
    }
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('cs-icon', {
    attrs: {
      "name": _vm.tab.icon,
      "color": _vm.iconColor
    }
  })], 1), _c('div', {
    staticClass: "help-link-container"
  }, [_vm.isShownHelpLink ? _c('help-link', {
    attrs: {
      "source": _vm.tab.helpLink
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t(_vm.tab.label)))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }